// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ChevronDown } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconChevronDown(props: any) {
    return <IconBase icon={ChevronDown} {...props} />
  }

  export default IconChevronDown
  